import { MultiUserFieldFilter } from 'module/types/filter-field/filter/multi-user';
import { FC, useMemo } from 'react';
import { MultiSelectBaseFilterToText } from './multi-select-base-filter';
import { UserOptionsGetter } from '../types';

interface Props {
  filter: MultiUserFieldFilter;
  optionsGetter?: UserOptionsGetter;
}
export const MultiUserFilterToText: FC<Props> = ({ filter, optionsGetter }) => {
  const options = useMemo(
    () =>
      optionsGetter != null
        ? optionsGetter(filter.field)
        : (filter.field.metaData.options ?? []),
    [filter.field, optionsGetter],
  );

  return <MultiSelectBaseFilterToText filter={filter} options={options} />;
};
